import type { MessageUiState } from '@elara/client-core/states/MessageUiState';

import { useRef } from 'react';

import { createThinkingIndicatorState, resolveThinkingIndicatorText } from '@elara/client-core/chat/thinking-indicator';

import { ThinkingText } from '#ui/index.js';

interface MessageThinkingIndicatorProps {
  state: MessageUiState;
}

export function MessageThinkingIndicator({ state }: MessageThinkingIndicatorProps) {
  const indicatorStateRef = useRef(createThinkingIndicatorState());
  const text = resolveThinkingIndicatorText(
    { messageId: state.viewId, content: state.content, toolCalls: state.toolCalls },
    indicatorStateRef.current,
  );
  return <ThinkingText text={text} />;
}
